// extracted by mini-css-extract-plugin
export var copilotInboxHighPriorityIconColor = "c9jhT";
export var copilotInboxLowPriorityIconColor = "HRfwZ";
export var copilotInboxNormalPriorityColor = "EMSgN";
export var copilotInboxPriorityHighContrastColor = "T1Kf6";
export var copilotInboxPriorityIconForMLStyles = "x712j";
export var copilotInboxPriorityIconForRPStyles = "PkYzF";
export var copilotInboxPriorityIconForRPStylesCozyAndCompact = "yOjIy";
export var copilotInboxPriorityIconForSettingsStyles = "kk_QZ";
export var iconContainer = "pe3au";